<template>
  <tr :class="[{'active': active}]">
    <td>

      <div class="d-flex">

      
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <div>
          
          <div
          class="underline-link"
          @click.stop="$root.$timelineNav.open(item.archive_id)">
            RID:
            {{ item.archive_id }}
          </div>

          <div v-if="item.batch_number" class="caption">
            <v-icon small>mdi-barcode</v-icon>
            {{ item.batch_number }}
          </div>

        </div>

      </div>

    </td>
    <td>
      <v-chip v-if="hasExpired"
      color="pink"
      x-small
      text-color="white">
        EXPIRED
      </v-chip>
      <div v-if="item.expiry_date" class="caption">
        {{ hasExpired? 'expired' : 'expires' }} {{ expiryDateHuman }} <br /> ({{ expiryDate }})
      </div>
      <div v-else class="caption textSecondary--text">
        (not set)
      </div>

      <!-- TIMELINE -->
      <!--
      <timeline :archive_id="item.archive_id"></timeline>
      -->
      <!-- TIMELINE -->

    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="item.id"
      alwaysScale
      labelMode
      ></c-ms-ii>

      <!--
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          small
          color="color1"
          v-on="on"
          @click.stop="$emit('editQuantity', item.id)"
          >
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
        </template>
        <span>Edit Quantity</span>
      </v-tooltip>
      -->

    </td>
  </tr>
</template>

<script>
import Timeline from '../../timeline/Main'

export default {
  props: ['item', 'searchFilters', 'active'],
  components: {
    Timeline
  },
  data () {
    return {
      
    }
  },
  computed: {
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD MMM YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    },
    hasExpired () {
      return this.$moment.utc(this.item.expiry_date).isBefore()
    }
  }
}
</script>